import React, { useRef, useContext, useEffect } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"


import ContentWrapper from "../../styles/contentWrapper"

import ContactForm from '../contactForm'

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';







const StyledSection = styled.section`
  width: 100%;
  height: auto;
  padding: 4rem 0;
  background: #F2F2F2;

`

const StyledContentWrapper = styled(ContentWrapper)`
  && {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: auto;
    padding-right: 1rem;
    padding-left: 1rem;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      padding-right: 2.5rem;
      padding-left: 2.5rem;
    }
    .section-title {
      font-style: normal;
      font-weight: 700;
      font-size: 2.4rem;
      line-height: 3rem;
      letter-spacing: -1.5px;
      color: #386097;
      margin: auto;
      span {
        color: #282A32;
      }
      text-align: center;
      margin-top: 0;
      margin-bottom: 1rem;
      padding: 0 1rem;
      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        padding-right: 0;
        padding-left: 0;
      }
    }
    .section-subtitle {
      color: #4E5D6B;
      font-size: 1rem;
      line-height: 1.5rem;
      text-align: center;
      margin-top: 0;
      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        padding-right: 0;
        padding-left: 0;
      }
    }
  }
`




const Contact = ({ content }) => {
  const { frontmatter, body } = content[0].node

  // Required for animating the text content


  return (
    <StyledSection id="Contact">
      <StyledContentWrapper>
        <h2 className="section-title">{frontmatter.title}</h2>
        <ContactForm />
      </StyledContentWrapper>
    </StyledSection>
  )
}

Contact.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      node: PropTypes.shape({
        body: PropTypes.string.isRequired,
        frontmatter: PropTypes.object.isRequired,
      }).isRequired,
    }).isRequired
  ).isRequired,
}

export default Contact
